import App from 'src/App.jsx';
import Root from 'src/Root';

// Catch-all page. Every URL that doesn't match a more specific Vike
// route (filesystem-mapped or parametric @param) lands here. The actual
// page is resolved by react-router inside <App />.
//
// Lives under pages/_catchall/ rather than pages/index/ because the
// homepage at `/` now has its own per-route OG metadata
// (pages/index/+title.ts etc.) — Vike's filesystem routing maps
// pages/index/ to `/` automatically when no +route.ts overrides.
export default function Page() {
   return (
      <Root>
         <App />
      </Root>
   );
}
